import React from 'react'
import { TableRowField } from '../../../../components'
import { formatHelper } from '../../../../common/helpers'

export const columnsPaymentDetailsXS = [
    {
        dataField: 'xs',
        text: 'Balance por Forma de Pago Detallado',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Cliente:' value={`${row.Customer.name} ${row.Customer.lastname}`} />
                    <TableRowField label='Forma de Pago:' value={row.Sell_payment_type.name} />
                    <TableRowField label='Total (S/):' value={formatHelper.toMoney(row.total_net)} />
                </div>
            )
        }
    }
]
export const columnsPaymentDetailsSM = [
    {
        dataField: 'xs',
        text: 'Balance por Forma de Pago Detallado',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Cliente:' value={`${row.Customer.name} ${row.Customer.lastname}`} />
                    <TableRowField label='Forma de Pago:' value={row.Sell_payment_type.name} />
                </div>
            )
        }
    },
    {
        dataField: 'total',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={formatHelper.toMoney(row.total_net)} />
                </div>
            )
        }
    }
];
export const columnsPaymentDetailsMD = [
    {
        dataField: 'client',
        text: 'Cliente',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={`${row.Customer.name} ${row.Customer.lastname}`} />
                </div>
            )
        }
    },
    {
        dataField: 'payment',
        text: 'Forma de Pago',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={row.Sell_payment_type.name} />
                </div>
            )
        }
    },
    {
        dataField: 'total',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={formatHelper.toMoney(row.total_net)} />
                </div>
            )
        }
    }
];

export const columnsPaymentSellsXS = [
    {
        dataField: 'xs',
        text: 'Ventas por Forma de Pago',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Forma de Pago:' value={row.name} />
                    <TableRowField label='Cantidad:' value={row.quantity} />
                    <TableRowField label='Total (S/):' value={formatHelper.toMoney(row.total)} />
                </div>
            )
        }
    }
]
export const columnsPaymentSellsSM = [
    {
        dataField: 'xs',
        text: 'Ventas por Forma de Pago',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Forma de Pago:' value={row.name} />
                    <TableRowField label='Cantidad:' value={row.quantity} />
                    <TableRowField label='Total (S/):' value={formatHelper.toMoney(row.total)} />
                </div>
            )
        }
    }
];
export const columnsPaymentSellsMD = [
    {
        dataField: 'payment',
        text: 'Forma de Pago',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={row.name} />
                </div>
            )
        }
    },
    {
        dataField: 'quantity',
        text: 'Cantidad',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={row.quantity} />
                </div>
            )
        }
    },
    {
        dataField: 'total',
        text: 'Total (S/)',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='' value={formatHelper.toMoney(row.total)} />
                </div>
            )
        }
    }
];


// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/PaymentBalance/_columns.js